import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Mouse movements in a day of coding",
  "description": "",
  "published": "2013-05-07T00:00:00.000Z",
  "redirect_from": ["/blog/mouse-movements-in-a-day-of-coding/swizec/6167"],
  "categories": "Emacs, Mouse, Ruby, Ubuntu, Uncategorized, Workspace",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few weeks ago I bought a fancy new `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mouse_%28computing%29",
        "title": "Mouse (computing)"
      }}>{`mouse`}</a>{` to replace my fancy old mouse. Sure it's nice and comfy, but how much do I actually use it? When you pay close to a hundred euro for something you want to make sure it's doing its job.`}</p>
    <p>{`Yesterday I tried.`}</p>
    <p>{`For the whole day, when the freelancing clock was running, so was `}<a parentName="p" {...{
        "href": "http://iographica.com/"
      }}>{`IOGraph`}</a>{` - a handy tool for recording mouse movements.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2013/05/a-day-of-coding.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2013/05/a-day-of-coding-1024x363.png",
          "alt": "A day of coding",
          "title": "A day of coding"
        }}></img></a></p>
    <p>{`I have dual screens, am running `}<a parentName="p" {...{
        "href": "http://www.ubuntu.com",
        "title": "Ubuntu (operating system)"
      }}>{`Ubuntu`}</a>{` and use `}<a parentName="p" {...{
        "href": "http://www.gnu.org/software/emacs",
        "title": "Emacs"
      }}>{`Emacs`}</a>{` to write code. Certainly the sort of environment that favours using your keyboard over your mouse and yet, the mouse gets used quite a lot.`}</p>
    <p>{`The image above shows paths my mouse has taken through the day, dots show where the mouse has been standing still for a while - the bigger the dot, the longer the time - and I am honestly not certain what the circles around small black dots are. Clicks perhaps?`}</p>
    <p>{`Other than the fact I use my mouse more than I thought, three patterns emerge.`}</p>
    <ol>
      <li parentName="ol">{`There is a blank space roughly down the middle where I never place my mouse - the dividing line between two monitors. You can see the left is wider than the right.`}</li>
      <li parentName="ol">{`Despite being used a lot, the mouse spends most of its time `}<strong parentName="li">{`standing still`}</strong>{`. Most of the image is taken up by relatively few very large black dots. The largest two are right where I had two terminal windows that I often switched between (one running a server instance, the other used for git). The rest are mostly on the far right where I have my browser. Apparently I like to click around, then leave the mouse there when I go back to coding? Or maybe page loads are slow?`}</li>
      <li parentName="ol">{`Emacs takes up the left half of the screen. I sometimes put my mouse here, but rarely for long because the cursor gets in the way.`}</li>
    </ol>
    <p>{`You can also notice I spend a lot of time switching the last few tabs in `}<a parentName="p" {...{
        "href": "http://www.google.com/chrome",
        "title": "Google Chrome"
      }}>{`Chrome`}</a>{`, possibly opening and closing them as I browse the interwebs for help with `}<a parentName="p" {...{
        "href": "http://www.ruby-lang.org/",
        "title": "Ruby (programming language)"
      }}>{`Ruby`}</a>{`? That's all the lines going to the upper right corner.`}</p>
    <p>{`Here's a screenshot of the desktop as I left it last night. Most of the tabs already closed because I have to save memory, but you can still see the rough layout of the windows I worked with. Had I some photoshop skill I'd overlay IOgraph output over the screenshot.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/05/Workspace-1_193-1024x363.png",
        "alt": "Workspace",
        "title": "Workspace"
      }}></img></p>
    <p>{`Now I wonder if mouse patterns are different for other languages and technology stacks ... I have experimenting to do!`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=638e0b4f-5b2f-4a1e-9476-a1d85e6bdfd9",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      